export default __webpack_public_path__ + "assets/images/g-icon9-606109b3.svg";